/** Commercial tenancy constants (C1A). */
/** Stable opaque id for the platform/default organization (seed & unassigned resources). */
export const PLATFORM_DEFAULT_ORGANIZATION_ID = "org_vital_platform";
/** Unique operational code for the platform/default organization. */
export const PLATFORM_DEFAULT_ORGANIZATION_CODE = "vital-platform";
/** Internal display name (not public portal branding). */
export const PLATFORM_DEFAULT_ORGANIZATION_NAME = "Tofan Portal Platform";
export const ORGANIZATION_STATUSES = ["draft", "active", "suspended", "archived"];
export const MEMBERSHIP_STATUSES = ["invited", "active", "suspended", "removed"];
export const PLATFORM_ROLES = ["owner", "operator"];
export const TENANT_ROLES = ["tenant_admin", "publisher", "editor", "auditor"];
//# sourceMappingURL=organizations.js.map